import { Switch } from '@blueprintjs/core'
import * as React from 'react'
import Help from '../../../../../components/Help'
import { GenericCheckbox } from '../../../../../components/Inputs'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const { props } = input

  const { helpText, ...childComponentProps } = props

  return (
    <div>
      <GenericCheckbox
        onChange={v => onFormPreviewChange(index, v)}
        title={props.label}
        requiredLabelStyle={templateStyles.requiredLabel}
        {...childComponentProps}
        required={props.required && !props.value}
      />
      {props.helpText && (
        <Help>
          <div>{props.helpText}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.props
  return (
    <div>
      <Switch
        checked={inputProps.value}
        label="Default Checked"
        onChange={() => onChange('value', !inputProps.value)}
      />

      <Switch
        checked={inputProps.alignRight}
        label="Align Right"
        onChange={() => onChange('alignRight', !inputProps.alignRight)}
      />
    </div>
  )
}
